import DashboardLayout from '../../components/dashboard/DashboardLayout';
import MyStayContent from '../../components/dashboard/MyStayContent';

const MyStayPage = () => {
  return (
    <DashboardLayout>
      <MyStayContent />
    </DashboardLayout>
  );
};

export default MyStayPage; 